import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import AutomaticStuffing from './AutomaticStuffing';
import BulkMailProjectManage from './BulkMailProjectManage';
import CustomizedSolutions from './CustomizedSolutions';
import Delivery from './Delivery';
import DigitalPrinting from './DigitalPrinting';
import MailRoomManagement from './MailRoomManagement';
import NormalBulkShipment from './NormalBulkShipment';
// import AirCargo from './AirCargo';
// import Chartered from './Chartered';
// import GSA from './GSA';
// import RushDelivery from './RushDelivery';

const MMS = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
    return(
        <div>
            <div id='international' className="mms-image">
                <img src='/MMs/main-banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    As Pakistan’s first and the fastest digital transactional printing facility, TCS offers end-to-end Mailroom 
                    Management Solutions (MMS) and Managed Printing Services (MPS), covering all aspects of printing and bulk 
                    distribution from designing and variable data printing, to auto-insertion, procurement, mailroom management, 
                    normal bulk shipment distribution, confirmation circulars delivery service, CNIC expiry info circular, 
                    debit/credit card delivery, CNIC delivery services and more.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="md:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/mms/digital-printing"  className='font-bold'>Digital Printing</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/mms/normal-bulk-shipment" className='font-bold'>Normal Bulk Shipment</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/mms/automatic-stuffing" className='font-bold'>Automatic Insertion</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/mms/mail-room-management" className='font-bold'>Mailroom Management</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/mms/bulk-mail-project" className='font-bold'>Bulk Mail Project Management</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/mms/delivery" className='font-bold'>Delivery</Link></li>
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/mms/customized-solutions" className='font-bold'>Customised Solutions</Link></li>
                            </div>
                            
                        </div>
                        
                            
                    </div>
                </div>
               
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="digital-printing">
                <DigitalPrinting />
            </div>
            <div id="normal-bulk-shipment">
                < NormalBulkShipment/>
            </div>
            <div id="automatic-stuffing">
                <AutomaticStuffing />
            </div>
            <div id="mail-room-management">
            <MailRoomManagement />
            </div>
            <div id="bulk-mail-project">
            <BulkMailProjectManage/>
            </div>
            <div id="delivery">
            <Delivery />
            </div>
            <div id="customized-solutions">
            <CustomizedSolutions />
            </div>
            </div>

        </div>
    )
};
export default MMS;